import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ClassificationInput, ClassificationOutput, ClassificationService } from '../classification-service';
import { FetchClassificationApi, type FetchClassificationRequest, type FetchClassificationResponse } from '../../apis/fetch-classification-api';

@injectable()
export class ClassificationServiceImpl implements ClassificationService {
    constructor(
        @inject(FetchClassificationApi)
        private readonly _fetchClassificationApi: FetchClassificationApi,
    ) {

    }

    fetch(data: ClassificationInput): Promise<ClassificationOutput[]> {
        return this._fetchClassificationRepository(data);
    }

    private async _fetchClassificationRepository(data: ClassificationInput) {
        const request: FetchClassificationRequest = {
            type: data.type,
            cid: data.value,
        };
        const response = await this._fetchClassificationApi.fetchClassification(request);
        const result = this._convertResToClassificationOutput(response);
        return result;
    }

    private _convertResToClassificationOutput(res: FetchClassificationResponse) {
        return res;
    }
}
